//const apiURL = window.inTest ? 'https://zelenekolo.cz.dev.poski.loc/zelenekolo-api/' : '/zelenekolo-api/';
const apiURL = '/zelenekolo-api/';

const getProjectConfigurator = async () => {
	try {
		const response = await fetch(`${apiURL}configuratorVueProject/vars.json`);
		return await response.json();
	} catch (error) {
		return Promise.reject(error);
	}
}

const getMaintenanceConfigurator = async () => {
	try {
		const response = await fetch(`${apiURL}configuratorVueMaintenance/vars.json`);
		return await response.json();
	} catch (error) {
		return Promise.reject(error);
	}
}

const getRealizationConfigurator = async () => {
	try {
		const response = await fetch(`${apiURL}configuratorVueRealization/vars.json `);
		return await response.json();
	} catch (error) {
		return Promise.reject(error);
	}
}

const getTextData = async () => {
	try {
		const response = await fetch(`${apiURL}text.json`);
		return await response.json();
	} catch (error) {
		return Promise.reject(error);
	}
}

const getDiscount = async (configuratorId, discountCode) => {
	try {
		const response = await fetch(`${apiURL}useDiscount/?discountCode=${discountCode}&configuratorId=${configuratorId}`);
		return await response.json();
	} catch (error) {
		return Promise.reject(error);
	}
}

const getGift = async (configuratorId, orderValue) => {
	try {
		const response = await fetch(`${apiURL}matchGift/?orderValue=${orderValue}&configuratorId=${configuratorId}`);
		return await response.json();
	} catch (error) {
		return Promise.reject(error);
	}
}

const postConfiguration = async formData => {
	try {
		const response = await fetch(`${apiURL}processConfiguration/`, {
			method: 'POST',
			body: formData
		});
		return await response.json();
	} catch (error) {
		return Promise.reject(error);
	}
}

const getConfigurationForEdit = async (id, hash) => {
	try {
		const response = await fetch(`${apiURL}order/${id}/${hash}.json`);
		return await response.json();
	} catch (error) {
		return Promise.reject(error);
	}
}

export {
	getProjectConfigurator,
	getMaintenanceConfigurator,
	getRealizationConfigurator,
	getTextData,
	postConfiguration,
	getConfigurationForEdit,
	getDiscount,
	getGift
}
